import { gql } from "@apollo/client";

const schema = {
  delete: {
    name: "deleteOrderAttachment",
    serviceName: "auth",
    query: gql`
      mutation deleteOrderAttachment($ids: [String]!) {
        deleteOrderAttachment(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
